import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import HeaderBigScreen from "./HeaderBigScreen.jsx";
import useIsSmallScreen from "../isSmallScreen.jsx";
import HeaderSmallScreen from "./HeaderSmallScreen.jsx";

const Header = () => {
  const isSmallScreen = useIsSmallScreen();
  const navigate = useNavigate();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    // If not on home page, navigate to home first
    if (location.pathname !== "/" && location.pathname !== "/Karina-website/") {
      navigate("/");
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <>
      {isSmallScreen ? (
        <HeaderSmallScreen
          isScrolled={isScrolled}
          scrollToSection={scrollToSection}
        />
      ) : (
        <HeaderBigScreen
          isScrolled={isScrolled}
          scrollToSection={scrollToSection}
        />
      )}
    </>
  );
};

export default Header;
